export const TRANSLATION_TEMPLATES = {
  TEMPLATE_CONTENT: 'template_content',
};
